import { render, staticRenderFns } from "./CountryPicker.vue?vue&type=template&id=2d23f93a&scoped=true&"
import script from "./CountryPicker.vue?vue&type=script&lang=js&"
export * from "./CountryPicker.vue?vue&type=script&lang=js&"
import style0 from "./CountryPicker.vue?vue&type=style&index=0&id=2d23f93a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d23f93a",
  null
  
)

export default component.exports